/**
 * MUFE Deferred frontend behaviors (non-critical path JS).
 *
 * This script is loaded with `defer`, meaning it runs only *after* the HTML is fully parsed.
 * Therefore, no need to wrap logic in `DOMContentLoaded` — the DOM is guaranteed to be ready.
 *
 * Responsibilities:
 * - Loads feature-level UI interactions: product variation logic, carousels, banners, video players, analytics.
 * - Executed asynchronously after initial paint, non-blocking.
 * - Contains MUFE-specific business logic and visual behaviors.
 */

/* eslint-disable no-undef */

var processInclude = require('base/util');

var IS_BAMBUSER_ENABLED = SitePreferences.IS_BAMBUSER_ENABLED;

(async () => {
    try {
        processInclude(require('./components/miniCart'));
        processInclude(require('app_custom_merge_mufe/components/stickyAddToCart'));
        processInclude(require('./components/newsletter'));
        processInclude(require('./components/lipIcon'));
        processInclude(require('./product/sliderRecommendation'));
        processInclude(require('./product/productListTracking'));
        processInclude(require('./product/sliderBambuserInspired'));
        processInclude(require('./components/utilities'));
        processInclude(require('app_custom_mufe/product/variationAttributes'));
        processInclude(require('app_custom_mufe/product/proSection'));
        processInclude(require('app_custom_mufe/components/search'));
        processInclude(require('app_custom_mufe/components/formFields'));
        processInclude(require('app_custom_mufe/gtm/gtmClick.js'));
        processInclude(require('app_custom_mufe/components/countDown'));
        processInclude(require('app_custom_merge_mufe/components/collapsibleItem'));
        processInclude(require('app_custom_merge_mufe/components/radioButtonADA'));
        processInclude(require('app_custom_mufe/footnoteADA'));
        processInclude(require('app_custom_mufe/owlCarouselADA'));
        processInclude(require('./components/countrySelector'));
        processInclude(require('./components/customSearch'));
        processInclude(require('./components/tabs'));
        processInclude(require('./components/socialMedia'));
        processInclude(require('./components/dialogs').init());
        processInclude(require('./homepage'));

        if (IS_BAMBUSER_ENABLED) {
            processInclude(require('app_custom_mufe/bambuser'));
            processInclude(require('./bambuserShoppable'));
        }

        require('app_custom_mufe/components/inputFile');
        require('app_custom_mufe/lib/tablistADA');
        require('jquery-ui/ui/widgets/autocomplete');

        // TODO Rework My Account
        processInclude(require('app_custom_mufe/account_revamp/orderDetails'));
    } catch (err) {
        console.log(err);
    }
})();